import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from 'react-toastify';

function PharmaProfile() {
    const [formData, setFormData] = useState({
            profile_pharma_name:'',
            profile_pharma_own_name: '',
            profile_pharma_dlno: '',
            profile_pharma_phone_no: '',
            profile_pharma_user: '',
            // profile_pharma_header:'',
            // profile_pharma_footer:'',
            alertMsg: '',
            alertMsgTyp: '',
            isAlert: false,
          });

          const [ldata, setLdata] = useState(null);
    const handleChange = (e) => {
       
        const { name, value } = e.target;
        setFormData(prev => ({
          ...prev,
          [name]: value
        }));
      };

      const handleSubmit = async (e) => {
        e.preventDefault();
        // alert(formData.email+"");
        const fd = new FormData();
        fd.append('profile_pharma_name', formData.profile_pharma_name);
        fd.append('profile_pharma_own_name', formData.profile_pharma_own_name);
        fd.append('profile_pharma_dlno', formData.profile_pharma_dlno);
        fd.append('profile_pharma_phone_no', formData.profile_pharma_phone_no);
        // fd.append('profile_pharma_header', document.getElementById("profile_pharma_header").files[0]);
        // fd.append('profile_pharma_footer', document.getElementById("profile_pharma_footer").files[0]);
        fd.append('profile_pharma_user', ldata.user_id);
        
        try {
            const response = await axios.post(AppConst.BASE_URL+AppConst.upProfileUrl2, fd, {
                headers: {
                'Content-Type': 'multipart/form-data',
                },
            });

            if(response.data.status){
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                  }));
                initData();
                toast.success("Updated successfully");

            }
            else{
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                  }));
                toast.error("Update failed");
            }
        } catch (error) {
            setFormData(prev => ({
                ...prev,
                isAlert: true,
                alertMsg: "Failed",
                alertMsgTyp: "danger",
              }));
        }
        
      };
    const initData = async() => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            
            if(parsed!=null && parsed!=undefined){
                const fd = new FormData();
                fd.append('profile_pharma_user', 1);
                try {
                    const response = await axios.post(AppConst.BASE_URL+AppConst.getProfileUrl2, fd, {
                        headers: {
                        'Content-Type': 'multipart/form-data',
                        },
                    });
                    if(response.data.status){
                        
                        var user_dt = response.data.user_dt;
                        if(user_dt!=null && user_dt!=undefined){
                            setFormData(prev => ({
                                ...prev,
                                profile_pharma_name:user_dt.profile_pharma_name,
                                profile_pharma_own_name: user_dt.profile_pharma_own_name,
                                profile_pharma_dlno: user_dt.profile_pharma_dlno,
                                profile_pharma_phone_no: user_dt.profile_pharma_phone_no,
                                profile_pharma_user: user_dt.profile_pharma_user,
                                // profile_pharma_header: user_dt.profile_pharma_header,
                                // profile_pharma_footer: user_dt.profile_pharma_footer
                              }));
                        }
                    }
                } catch (error) {
                   
                }
            }
        }
      };

    useEffect(() => {
        console.log('Component mounted');
    
        initData();
    
        return () => {
          console.log('Component unmounted');
        };
      }, []);
    return (
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                {/* <div class="col-xxl-2"></div> */}
                    <div class="col-xxl-12">
                        <div class="card">
                            

                            <div class="card-body">
                                <h5>Pharmacy Profile</h5>
                                <br/>
                                <div class="live-preview">
                                    <form onSubmit={handleSubmit}>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">Pharmacy Name </label>
                                                    <input type="text" name="profile_pharma_name" onChange={handleChange} value={formData.profile_pharma_name} class="form-control" placeholder="Enter your Pharmacy Name" required/>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label for="lastNameinput" class="form-label">Ownwer Name</label>
                                                    <input type="text" name="profile_pharma_own_name" onChange={handleChange} value={formData.profile_pharma_own_name} class="form-control" placeholder="Enter your Ownwer Name"  required/>
                                                </div>
                                            </div>
                                           
                                            <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label for="compnayNameinput" class="form-label">DL. NO.</label>
                                                    <input type="text" name="profile_pharma_dlno" onChange={handleChange} value={formData.profile_pharma_dlno} class="form-control" placeholder="Enter DL. NO."  required/>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label for="phonenumberInput" class="form-label">Phone No</label>
                                                    <input type="tel" name="profile_pharma_phone_no" onChange={handleChange} value={formData.profile_pharma_phone_no} class="form-control" placeholder="Phone No"  required/>
                                                </div>
                                            </div>
                                            {/* <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label for="phonenumberInput" class="form-label">Upload Header</label>
                                                    <input type="file" id="profile_pharma_header" class="form-control"/>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label for="phonenumberInput" class="form-label">Upload Footer</label>
                                                    <input type="file" id="profile_pharma_footer"  class="form-control"/>
                                                </div>
                                            </div> */}
                                           
                                            <div class="col-lg-12">
                                                <div class="text-end">
                                                    <button type="submit" class="btn btn-primary">Submit</button>
                                                </div>
                                            </div>
                                            
                                        </div>
                                        
                                    </form>
                                </div>
                                
                            </div>
                        </div>
                    </div> 
                    {/* <div class="col-xxl-2"></div> */}
                </div>
            </div>
        </div>
    );
}

export default PharmaProfile;
